import { connect } from 'react-redux';
import AiAssistantSidePanel from '../../components/AiAssistant/AiAssistantSidePanel/aiAssistantSidePanel';

export default connect((state) => {
  let sData = state.aiAssistant;

  return {
    sData,
    showSidePanel: sData.get('showSidePanel'),
  };
})(AiAssistantSidePanel);
